export const PKG_NAME = "@hpcc-js/composite";
export const PKG_VERSION = "2.9.9";
export const BUILD_VERSION = "2.108.11";
